export default __webpack_public_path__ + "static/racing-1600x900-349d33bfe3c6ec809dde32a706a84ee0.jpg";